module.exports = __webpack_public_path__ + "img/DE05902.0e4eb8be.png";